export { VisualAssetImage } from './VisualAssetImage';
export { getVisualAssetImageSrc } from './getVisualAssetImageSrc';
